import { ContractDuration, GenderOrPrenatal, Insurer } from '../../../api';

export const genderNames: {
  [key in GenderOrPrenatal]: string;
} = {
  FEMALE: 'Female',
  MALE: 'Male',
  PRENATAL: 'Prenatal',
};

export const CURRENCY_CHF = 'CHF';

export const CATEGORY = {
  BASIC_INSURANCE: 'Basic Insurance',
  SUPPLEMENTARY_INSURANCE: 'Supplementary Insurance',
};

export const CATEGORY_ID = {
  BASIC_INSURANCE: 'basic-insurance',
  SUPPLEMENTARY_INSURANCE: 'supplementary-insurance',
};

export function mapCustomerType(totalPersons: number): string {
  return totalPersons > 1 ? 'Multiple People' : 'Single Person';
}

export function mapFranchise(franchise: string): string {
  return franchise.slice(franchise.indexOf('_') + 1);
}

export function mapAccidentCoverage(includesAccidentCoverage: boolean): string {
  return includesAccidentCoverage ? 'With accident cover' : 'Without accident cover';
}

export function mapContractLength(contractDuration: ContractDuration): string {
  switch (contractDuration) {
    case 'ONE_YEAR':
      return '1 Year';
    case 'THREE_YEARS':
      return '3 Years';
    case 'FIVE_YEARS':
      return '5 Years';
  }
}

export function mapExistingCustomer(existingCustomer: boolean): string {
  return existingCustomer ? 'Is client' : 'No client';
}

export function mapBrand(insurer: Insurer): string {
  switch (insurer) {
    case 'VISANA':
      return 'Visana';
    case 'SANA24':
      return 'Sana24';
    case 'GALENOS':
      return 'Galenos';
  }
}
